import { ChainId } from "@pancakeswap/sdk"


export const getChainName = (chainId:number) => {
    switch (chainId) {
        case ChainId.BSC:
            return "BNB Chain"
        case ChainId.ONUS:
            return "ONUS Chain"
        case ChainId.BSC_TESTNET:
            return "BNB Testnet"
        default:
            return "ONUS Chain"
    }
}